<template>
	<section>
		<!--工具条-->
		<el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
			<el-form :inline="true" :model="filters">
				<el-form-item>
					<el-input v-model="filters.code" placeholder="编号" @keyup.enter.native="getLists"></el-input>
				</el-form-item>
				<el-form-item>
					<el-input v-model="filters.name" placeholder="名称" @keyup.enter.native="getLists"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" icon="el-icon-search" @click="getLists">搜索</el-button>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="handleAdd">新增</el-button>
				</el-form-item>
			</el-form>
		</el-col>
		<!--列表-->
		<el-table :data="datalist" border stripe highlight-current-row v-loading="listLoading" style="width:90%;" height="600">
			<el-table-column prop="entime" label="时间" min-width="100"></el-table-column>
			<el-table-column prop="code" label="编号" min-width="100"></el-table-column>
			<el-table-column prop="name" label="名称" min-width="100"></el-table-column>
		
			<el-table-column prop="valid" label="状态" min-width="100" :formatter="formatValid"></el-table-column>
			<el-table-column label="操作" fixed="right" width="150">
				<template slot-scope="scope">
					<div>
						<el-button type="text" size="small" @click="handleEditUser(scope.$index, scope.row)">同步</el-button>
						<el-button type="text" size="small" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
						<el-button type="text" size="small" @click="handleDel(scope.$index, scope.row)">删除</el-button>
					</div>
				</template>
			</el-table-column>
		</el-table>
		<!--工具条翻页-->
		<el-col :span="24" class="toolbar">
		<el-pagination layout="total,prev, pager, next" @current-change="handleCurrentChange" :page-size="pagesize" :total="total" style="float:right;"></el-pagination>
		</el-col>

		<!--编辑界面-->
		<el-dialog :title="editformtitle" :visible.sync="editFormVisible" :close-on-click-modal="false">
			<el-form :model="editForm" label-width="100px" :rules="formRules" ref="editForm">
				<el-form-item label="编号" prop="code">
					<el-input v-model="editForm.code" placeholder="编号"></el-input>
				</el-form-item>
				<el-form-item label="名称" prop="name">
					<el-input v-model="editForm.name" placeholder="名称"></el-input>
				</el-form-item>
				<el-form-item label="分成比例" prop="jsbl">
					<el-input v-model="editForm.jsbl" placeholder="密码"></el-input>
				</el-form-item>
				<el-form-item label="状态" prop="valid">
					<el-select v-model="editForm.valid" placeholder="请选择状态">
						<el-option label="有效" value="1"></el-option>
						<el-option label="无效" value="0"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="是否获取当天数据" prop="is_get_today">
					<el-select v-model="editForm.is_get_today" placeholder="请选择状态">
						<el-option label="是" value="1"></el-option>
						<el-option label="否" value="0"></el-option>
					</el-select>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="editFormVisible = false">取消</el-button>
				<el-button type="primary" @click.native="editSubmit" :loading="editLoading">提交</el-button>
			</div>
		</el-dialog>
	</section>
</template>
<script>
	import util from '../../common/js/util'
	import { getListPage, delData, saveData } from '../../api/api';
	export default {
		data() {
			return {
				filters:{
					code:'',name:''
				},
				datalist: [],
				total: 0,
				pagesize:20,
				page: 1,
				listLoading: false,
				/////////////Form 表单
				editformtitle:'',//form编辑名称
				editFormVisible: false,//编辑界面是否显示
				editLoading: false,
				formRules: {
					code :[
						{required: true,message: '编号不能为空!',trigger: 'blur'}
					],
					name :[
						{required: true,message: '名称不能为空!',trigger: 'blur'}
					],
				},
				//编辑界面数据
				editForm: {
					actionurl:'',sqlid:'',entime:'',code:'',name:'',passwd:'',valid:'',is_get_today:'',jsbl:'80'
				}
			}
		},
		methods: {
			handleCurrentChange(val) {
				this.page = val;
				this.getLists();
			},
			formatValid: function (row, column) {
				return row.valid == 1 ? '有效' : row.valid == 0 ? '无效' : '未知';
			},
			getLists:function(){
				let para = {
					page: this.page,
					pagesize:this.pagesize,
					actionurl:'default/getList',
					code:this.filters.code,
					name:this.filters.name,
					sqlid:'html_cpinfo.query'
				};
				this.listLoading = true;
				getListPage(para).then((res) => {
					if(!util.checkLogOut(this,res.data)){
						this.total = res.data.total;
						this.datalist = res.data.datas;
					}
					this.listLoading = false;
				});
			},
			handleAdd:function(){
				this.editFormVisible = true;
				this.editformtitle = '新增';
				this.editForm = {
					actionurl:'default/save',sqlid:'html_cpinfo.add',entime:'',code:'',name:'',passwd:'',valid:'',is_get_today:'',jsbl:'80'
				};
			},
			handleEditUser: function (index, row) {
				let para = {
					actionurl:'datas/createLoginUser',
					username:row.name,
					name:row.name,
					cpcode:row.code
				};
				delData(para).then((res) => {
					this.listLoading = false;
					this.$message({message: res.data.message,type: res.data.type});
				});
			},
			handleEdit: function (index, row) {
				this.editFormVisible = true;
				this.editformtitle = '编辑';
				this.editForm = Object.assign({}, row);
				this.editForm.actionurl = 'default/save';//设置Sqlid
				this.editForm.sqlid = 'html_cpinfo.upt';
			},
			editSubmit:function(){
				let para = Object.assign({}, this.editForm);
				util.saveFunction(this,para);
			},
			handleDel: function (index, row) {
				this.$confirm('确认删除该记录吗?', '提示', {type: 'warning'}).then(() => {
					this.listLoading = true;
					let para = {
						actionurl:'default/del',
						sqlid:'html_cpinfo.del',
						id:row.id
					};
					delData(para).then((res) => {
						this.listLoading = false;
						this.$message({message: res.data.message,type: res.data.type});
						this.getLists();
					});
				}).catch(() => {});
			}
		},
		mounted() {
			this.getLists();
		}
	}	
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// cpinfo.vue?11579aac